module.exports = __webpack_public_path__ + "/images/ico-nav-hucha.3f676d7.svg";